import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoadingService } from '../../services/loading.service';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { EditDialogInstance } from '../editDialog/editDialogService';
import { EventSubscription, EventSubscriptionInput } from '../../entities/events/event';
import { EventSubscriptionService } from '../../services/eventSubscription/eventSubscriptionService';
import { EditSelectable } from '../edit-select-form-control/edit-select-form-control.component';

@Component({
  selector: 'app-subscription-dialog',
  templateUrl: './subscription-dialog.component.html',
  styleUrls: ['./subscription-dialog.component.scss']
})
export class SubscriptionDialogComponent
  implements EditDialogInstance {

  subscriptionForm: FormGroup;
  subscription: EventSubscription;

  eventTypes = [
    // Generic Events
    { id: 'lineItem.created', name: 'lineItem.created' },
    { id: 'lineItem.completed', name: 'lineItem.completed' },
    { id: 'lineItem.archived', name: 'lineItem.archived' },
    { id: 'order.created', name: 'order.created' },
    { id: 'order.completed', name: 'order.completed' },
    { id: 'order.archived', name: 'order.archived' },
    { id: 'resourceAssignment.created', name: 'resourceAssignment.created' },
    { id: 'resourceAssignment.completed', name: 'resourceAssignment.completed' },
    { id: 'resourceAssignment.archived', name: 'resourceAssignment.archived' },
    { id: 'tour.started', name: 'tour.started' },
    { id: 'tour.created', name: 'tour.created' },
    { id: 'tour.paused', name: 'tour.paused' },
    { id: 'tour.continued', name: 'tour.continued' },
    { id: 'tour.finished', name: 'tour.finished' },
    { id: 'tour.archived', name: 'tour.archived' },
    { id: 'tour.updated', name: 'tour.updated' },
    // Events für RENTAL
    { id: 'rental.lineItem.created', name: 'rental.lineItem.created' },
    { id: 'rental.lineItem.completed', name: 'rental.lineItem.completed' },
    { id: 'rental.lineItem.archived', name: 'rental.lineItem.archived' },
    { id: 'rental.order.created', name: 'rental.order.created' },
    { id: 'rental.order.completed', name: 'rental.order.completed' },
    { id: 'rental.order.archived', name: 'rental.order.archived' },
    { id: 'rental.resourceAssignment.out.scheduled', name: 'rental.resourceAssignment.out.scheduled' },
    { id: 'rental.resourceAssignment.out.onLocation.scheduled', name: 'rental.resourceAssignment.out.onLocation.scheduled' },
    { id: 'rental.resourceAssignment.out.onTour.scheduled', name: 'rental.resourceAssignment.out.onTour.scheduled' },
    { id: 'rental.resourceAssignment.out.canceled', name: 'rental.resourceAssignment.out.canceled' },
    { id: 'rental.resourceAssignment.in.scheduled', name: 'rental.resourceAssignment.in.scheduled' },
    { id: 'rental.resourceAssignment.in.onLocation.scheduled', name: 'rental.resourceAssignment.in.onLocation.scheduled' },
    { id: 'rental.resourceAssignment.in.onTour.scheduled', name: 'rental.resourceAssignment.in.onTour.scheduled' },
    { id: 'rental.resourceAssignment.in.onTour.completed', name: 'rental.resourceAssignment.in.onTour.completed' },
    { id: 'rental.resourceAssignment.out.onTour.completed', name: 'rental.resourceAssignment.out.onTour.completed' },
    { id: 'rental.resourceAssignment.in.completed', name: 'rental.resourceAssignment.in.completed' },
    { id: 'rental.resourceAssignment.reviewed', name: 'rental.resourceAssignment.reviewed' },
    { id: 'rental.resourceAssignment.completed', name: 'rental.resourceAssignment.completed' },
    { id: 'rental.resourceAssignment.archived', name: 'rental.resourceAssignment.archived' },
    { id: 'rental.resourceAssignment.refueled', name: 'rental.resourceAssignment.refueled' },
    { id: 'rental.resourceAssignment.out.tour.started', name: 'rental.resourceAssignment.out.tour.started' },
    { id: 'rental.resourceAssignment.in.tour.started', name: 'rental.resourceAssignment.in.tour.started' },
    { id: 'rental.resourceAssignment.out.completed', name: 'rental.resourceAssignment.out.completed' },
    // Events für OPERATED_RENTAL
    { id: 'operatedRental.order.created', name: 'operatedRental.order.created' },
    { id: 'operatedRental.order.completed', name: 'operatedRental.order.completed' },
    { id: 'operatedRental.order.archived', name: 'operatedRental.order.archived' },
    { id: 'operatedRental.order.taskAssigned', name: 'operatedRental.order.taskAssigned' },
    { id: 'operatedRental.order.taskCompleted', name: 'operatedRental.order.taskCompleted' },
    { id: 'operatedRental.order.refueled', name: 'operatedRental.order.refueled' },
    // Test Event
    { id: 'testEvent.created', name: 'testEvent.created' },
    { id: 'export.completed', name: 'export.completed' }
  ];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public loadingService: LoadingService,
    public eventSubscriptionService: EventSubscriptionService
  ) {

    if (this.config.data) {
      this.subscription = this.config.data;
    }

    this.subscriptionForm = new FormGroup({});
    this.subscriptionForm.addControl('id', new FormControl());
    // add form controls
    this.subscriptionForm.addControl('externalId', new FormControl());
    this.subscriptionForm.addControl('url', new FormControl(undefined, [Validators.required, Validators.pattern('https?://.+')]));
    this.subscriptionForm.addControl('active', new FormControl());
    this.subscriptionForm.addControl('eventTypes', new FormControl(undefined, Validators.required));
    this.subscriptionForm.addControl('type', new FormControl('WEBHOOK', Validators.required));
    this.subscriptionForm.addControl('customHtmlHeaders', new FormControl());
    if(!this.subscription) {
      this.subscriptionForm.addControl('secret', new FormControl(''));
    }

    if (this.subscription) {
      this.subscriptionForm.patchValue(this.subscription);
    }

  }


  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    this.loadingService.setLoading(true);
    console.log('SubscriptionDialogComponent onConfirm', this.subscriptionForm.value);
    let subcriptionInput = new EventSubscriptionInput(this.subscriptionForm.value);
    if (this.subscription) {
      this.eventSubscriptionService.update(subcriptionInput, (result: any) => {
        this.loadingService.setLoading(false);
        this.ref.close(result?.data?.updateEventSubscription?.id);
      });
    } else {
      this.eventSubscriptionService.create(subcriptionInput, (result: any) => {
        this.loadingService.setLoading(false);
        this.ref.close(result?.data?.createEventSubscription?.id);
      });
    }
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.subscriptionForm;
  }

}
